import * as React from "react";
const SvgFiRrKiwiFruit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-kiwi-fruit_svg__a)">
      <path
        fill="#062147"
        d="M12.373 11.58c.284.467.627 1.097.627 1.42a1 1 0 0 1-2 0c0-.323.343-.953.627-1.42.17-.28.576-.28.746 0m0-5.159c.284-.467.627-1.097.627-1.42a1 1 0 0 0-2 0c0 .323.343.953.627 1.42.17.28.576.28.746 0M5 10.001c.323 0 .953-.343 1.42-.627a.436.436 0 0 0 0-.746c-.467-.284-1.097-.627-1.42-.627a1 1 0 0 0 0 2m12.58-.627c.467.284 1.097.627 1.42.627a1 1 0 0 0 0-2c-.323 0-.953.343-1.42.627a.436.436 0 0 0 0 .746m-1.9-2.136c.536-.107 1.232-.282 1.469-.501a1 1 0 0 0-1.355-1.471c-.238.219-.469.898-.62 1.423a.437.437 0 0 0 .506.549m-7.387 0a.437.437 0 0 0 .506-.549c-.151-.525-.382-1.204-.62-1.423a1 1 0 0 0-1.355 1.471c.238.219.933.394 1.469.501m7.416 3.526a.437.437 0 0 0-.506.549c.151.525.382 1.204.62 1.423a1 1 0 0 0 1.355-1.471c-.238-.219-.933-.394-1.469-.501m-7.416 0c-.536.107-1.232.282-1.469.501a1 1 0 0 0 1.355 1.471c.238-.219.469-.898.62-1.423a.437.437 0 0 0-.506-.549m15.708-1.763v3c0 6.617-5.383 12-12 12S0 18.617 0 12V9c0-4.962 5.383-9 12-9s12 4.038 12 9zm-22 0c0 3.86 4.486 7 10 7s10-3.14 10-7-4.486-7-10-7S2 5.14 2 9zm19.738 5.238c-2.18 2.273-5.728 3.762-9.738 3.762s-7.558-1.489-9.738-3.762c1.02 4.439 4.995 7.762 9.738 7.762s8.718-3.323 9.738-7.762m-9.738-4.238c1.657 0 3-.448 3-1s-1.343-1-3-1-3 .448-3 1 1.343 1 3 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-kiwi-fruit_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKiwiFruit;
